import { Button, Form, Input, Modal } from 'antd'
import { useForm } from 'antd/es/form/Form'
import React, { useState } from 'react'
import { changeAdministratiorPSW } from '../../../../api/api'
const ResetPassword = (props) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [form] = useForm()
  const showModal = () => {
    setIsModalOpen(true)
  }

  const handleOk = () => {
    form.validateFields().then((res) => {
      console.log(res)
      const params = {
        password: res.password,
        id: props.info.id,
      }
      changeAdministratiorPSW(params).then((res) => {
        console.log(res)
      })
      setIsModalOpen(false)
    })
  }
  const handleCancel = () => {
    setIsModalOpen(false)
  }
  return (
    <div className="resetPassword">
      <a onClick={showModal}>修改密码</a>
      <Modal
        title="修改密码"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <Form
          labelCol={{
            span: 6,
          }}
          wrapperCol={{
            span: 18,
          }}
          form={form}
        >
          <Form.Item
            rules={[
              {
                required: true,
                message: '请输入密码！',
              },
              {
                // 校验密码
                validator: (rule, value, callback) => {
                  // 校验密码强度
                  //密码必须包含字母，数字，特殊符号中的两种
                  const passwordReg =
                    /^(?![a-zA-Z]+$)(?![0-9]+$)(?![\W_]+$)/
                  if (value) {
                    if (!passwordReg.test(value)) {
                      callback(
                        new Error(
                          '密码必须包含字母、数字、特殊符号的两种及以上'
                        )
                      )
                    }
                  } 
                    callback()
                },
              },
            ]}
            label="请输入密码"
            name="password"
          >
            <Input
              style={{ width: '300px' }}
              placeholder="请包含字母、数字、特殊符号的两种及以上"
            />
          </Form.Item>
          <Form.Item
            rules={[
              {
                required: true,
                message: '请再次输入密码！',
              },
              {
                validator: (rule, value, callback) => {
                  const password = form.getFieldValue('password')
                  const reInput = form.getFieldValue('reInput')
                  if (password && password !== reInput) {
                    callback(new Error('两次密码输入不一致'))
                  } else {
                    // Note: 必须总是返回一个 callback，否则 validateFieldsAndScroll 无法响应
                    callback()
                  }
                },
              },
            ]}
            label="请再次输入密码"
            name="reInput"
          >
            <Input style={{ width: '300px' }} />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  )
}
export default ResetPassword
